import { DrawAction, DrawOptions } from '../draw-action';

export abstract class FigureDrawAction extends DrawAction {

    /**
     * Returns the fabric.Object
     * @param {DrawOptions} options
     * @returns {any}
     */
    abstract createCanvasElement(options?: DrawOptions): any;
}
